import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.PRIMARY};
  padding: 1rem;
  margin-bottom: 1.6rem;

  border: none;
  border-radius: 4px;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};

  :hover:not([disabled]) {
    cursor: pointer;
  }

  p {
    font-family: Source Sans Pro;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.8rem;
    letter-spacing: 0em;
    text-align: center;

    color: ${({ theme }) => theme.colors.WHITE};

    @media only screen and (min-width: 768px) {
      font-size: 2.2rem;
      line-height: 2.8rem;
    }
  }
`;
